import React from 'react';

// VERY lightweight markdown-to-HTML (only what we need).
// Supports: headings (#..), bold ** **, italics * *, inline code `code`,
// unordered lists (-, *), numbered lists (1.), tables (|col|...), line breaks,
// and escapes leading/trailing asterisks already stripped earlier.
function toHtml(src = '') {
  let text = src.trim();

  // Normalize Windows newlines
  text = text.replace(/\r\n/g, '\n');

  // Code (inline) – simple
  text = text.replace(/`([^`]+)`/g, '<code style="background:#f5f5f5;padding:2px 4px;border-radius:4px;font-size:90%;">$1</code>');

  // Headings
  text = text.replace(/^######\s+(.*)$/gm, '<h6>$1</h6>')
             .replace(/^#####\s+(.*)$/gm, '<h5>$1</h5>')
             .replace(/^####\s+(.*)$/gm, '<h4>$1</h4>')
             .replace(/^###\s+(.*)$/gm, '<h3>$1</h3>')
             .replace(/^##\s+(.*)$/gm, '<h2>$1</h2>')
             .replace(/^#\s+(.*)$/gm, '<h1>$1</h1>');

  // Bold / Italic (do bold first)
  text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/\*([^*\n]+)\*/g, '<em>$1</em>');

  // Tables: detect blocks with pipes
  text = text.replace(/(^\|.+\|\s*$\n(?:^\|.*\|\s*$\n?)*)/gm, block => {
    const rows = block.trim().split('\n').map(r => r.trim()).filter(Boolean);
    if (!rows.length) return block;
    const header = rows[0];
    let bodyRows = rows.slice(1);

    // Remove separator row if present (---|---)
    if (bodyRows[0] && /^\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?$/.test(bodyRows[0])) {
      bodyRows = bodyRows.slice(1);
    }

    const toCells = line => line.replace(/^\|/, '').replace(/\|$/, '').split('|').map(c => c.trim());
    const headerCells = toCells(header);

    const thead = '<thead><tr>' + headerCells.map(c => `<th style="text-align:left;padding:4px 8px;border-bottom:1px solid #ddd;">${c}</th>`).join('') + '</tr></thead>';
    const tbody = '<tbody>' + bodyRows.map(r => {
      const cells = toCells(r);
      return '<tr>' + cells.map(c => `<td style="padding:4px 8px;border-bottom:1px solid #f0f0f0;vertical-align:top;">${c}</td>`).join('') + '</tr>';
    }).join('') + '</tbody>';

    return `<table style="border-collapse:collapse;width:100%;margin:8px 0;font-size:14px;">${thead}${tbody}</table>`;
  });

  // Lists (unordered)
  text = text.replace(/(^|\n)([\t ]*)([-*])\s+([^\n]+)/g, (m, pre, indent, bullet, item) =>
    `${pre}<li>${item.trim()}</li>`
  );
  // Wrap consecutive <li> ... into <ul>
  text = text.replace(/(?:\s*<li>.*?<\/li>)+/gs, block => `<ul style="margin:6px 0 10px 18px;padding:0;list-style:disc;">${block}</ul>`);

  // Numbered lists
  text = text.replace(/(^|\n)([\t ]*)\d+\.\s+([^\n]+)/g, (m, pre, indent, item) =>
    `${pre}<li>${item.trim()}</li>`
  );
  text = text.replace(/(?:\s*<li>.*?<\/li>)+/gs, block => {
    // Avoid re-wrapping already wrapped UL
    if (/^<ul/.test(block)) return block;
    return `<ol style="margin:6px 0 10px 18px;padding:0;list-style:decimal;">${block}</ol>`;
  });

  // Paragraphs: split by double newline, wrap plain text lines not already HTML block
  const blocks = text.split(/\n{2,}/).map(chunk => {
    if (/^\s*<(h\d|ul|ol|li|table|blockquote|p|code)/i.test(chunk)) return chunk;
    return `<p style="margin:8px 0;line-height:1.45;">${chunk.replace(/\n+/g, '<br/>')}</p>`;
  });
  return blocks.join('');
}

export const Markdown = ({ text }) => {
  const __html = toHtml(text || '');
  return <div className="markdown-render" style={{ fontSize: 14, lineHeight: 1.45 }} dangerouslySetInnerHTML={{ __html }} />;
};

export default Markdown;
